var path = 'app/reporting/site_specific/hardlinkAnalytics.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;